module.exports = __webpack_public_path__ + "img/hours.097e2790.jpg";